const core = {
  revisionInstructionTooLong: '修正指示は{{count}}文字以内で入力してください。入力内容は保持されています。',
  limitsTitle: '入力できる文字数・件数',
  limitsClaim: '主張: 最大 {{count}} 文字',
  limitsEvidence: '根拠: 最大 {{count}} 文字',
  limitsCausalClaims: '因果仮説: 最大 {{count}} 件',
  limitsInstruction: 'AIへの修正指示: 最大 {{count}} 文字',
  backToHistory: '分析履歴に戻る',
  title: 'DRBFM',
  description: '設計変更に基づく故障モード分析を実施します',
  newAnalysis: '新規分析',
  sessionHistory: '分析履歴',
  steps: {
      input: '入力',
      processing: '処理中',
      results: '結果',
    },
  input: {
      title: '分析データ入力',
      description: '設計変更の対象となる部品名と、旧仕様書・新仕様書の内容を入力してください。',
      basicInfo: '基本情報',
      itemName: '部品名',
      itemNamePlaceholder: '例: ブレーキパッド、ECU基板',
      itemNameHelper: '分析対象の部品名を入力してください',
      analysisTitle: '分析タイトル',
      analysisTitlePlaceholder: '例: 2024年モデル仕様変更分析',
      analysisTitleHelper: '任意で分析タイトルを設定できます',
      specifications: '仕様書',
      specificationsHelp: '旧仕様書と新仕様書の内容を入力してください。テキストを直接入力するか、ファイルから読み込むことができます。',
      oldSpecification: '旧仕様書',
      oldSpecPlaceholder: '旧仕様書の内容をここに入力...\n\n例:\n材質: SUS304\n厚さ: 2.0mm\n表面処理: 無\n公差: ±0.1mm',
      newSpecification: '新仕様書',
      newSpecPlaceholder: '新仕様書の内容をここに入力...\n\n例:\n材質: SUS316L\n厚さ: 1.8mm\n表面処理: Niメッキ\n公差: ±0.05mm',
      selectDocument: 'ドキュメントから選択',
      loadFromDocument: 'ドキュメントから読み込み',
      startAnalysis: '分析開始',
      starting: '分析を開始中...',
      analysisInfo: 'AIが仕様書を比較し、変更点を抽出して故障モード分析を行います。分析には数分かかる場合があります。',
      // Input mode tabs
      documentMode: 'ドキュメント選択',
      textMode: 'テキスト入力',
      selectOldSpec: '旧仕様書を選択',
      selectNewSpec: '新仕様書を選択',
    },
  documentSelector: {
      selectDocument: 'ドキュメントを選択',
      searchPlaceholder: 'ドキュメントを検索...',
      searchHelp: '登録済み文書をタイトル・説明・ファイル名・カテゴリ・タグから検索できます。未登録の仕様書は先にドキュメント画面から登録してください。',
      resultsCount: '{{shown}} / {{total}} 件を表示',
      loadMore: 'さらに表示',
      loadingMore: '読み込み中...',
      selected: '選択済み',
      change: '変更',
      fetchError: 'ドキュメント一覧の取得に失敗しました',
      contentError: 'ドキュメントの内容を取得できませんでした',
      noResults: '検索結果がありません',
      noDocuments: 'ドキュメントがありません',
      loadingContent: 'コンテンツを読み込み中...',
      documentSelected: 'ドキュメント選択済み',
    },
  history: {
      title: '分析履歴',
      back: 'DRBFMへ戻る',
      noSessions: '分析履歴がありません',
      newAnalysis: '新規分析',
      startFirst: '最初の分析を始める',
      columnItem: '対象部品',
      columnTitle: 'タイトル',
      columnAnalysis: '分析対象',
      columnStatus: 'ステータス',
      columnCreated: '作成日時',
      columnCompleted: '完了日時',
      columnActions: '操作',
      resume: '編集を再開',
      viewResults: '結果を表示',
      view3D: '3Dで見る',
      export: 'エクスポート',
      delete: '削除',
      deleteTitle: '分析結果を削除',
      deleteConfirm: '「{{itemName}}」の分析結果を削除してもよろしいですか？この操作は取り消せません。',
      exportError: 'エクスポートに失敗しました',
      statusCompleted: '完了',
      statusProcessing: '処理中',
      statusFailed: '失敗',
      statusDraft: '下書き',
      preview: 'プレビュー',
      exportExcel: 'Excel出力',
      previewTitle: 'DRBFM分析結果プレビュー',
      previewFrameTitle: 'DRBFMプレビュー',
      previewError: 'プレビューの読み込みに失敗しました',
      resultsFetchFailed: 'DRBFM結果の取得に失敗しました',
    },
  processing: {
    flowLabel: 'フロー{{id}}: {{label}}',
      title: '分析処理中',
      description: 'AIが設計変更を分析しています。完了までお待ちください。',
      analyzing: '分析中...',
      pleaseWait: 'しばらくお待ちください',
      overallProgress: '全体進捗',
      flowStatus: 'フロー状態',
      progressLog: '進捗ログ',
      creatingSession: 'セッションを作成中...',
      flow1: {
        title: '変更点抽出',
        description: '旧仕様書と新仕様書を比較して変更点を抽出します',
      },
      flow2: {
        title: '知識ベース検索',
        description: '過去トラブルや設計基準書から関連情報を検索します',
      },
      flow3: {
        title: '故障モード分析',
        description: '変更点に関連する潜在的な故障モードを特定します',
      },
      flow4: {
        title: '対策案生成',
        description: '故障モードに対する効果的な対策案を生成します',
      },
      flow5: {
        title: 'レポート生成',
        description: 'DRBFMテーブルとレポートを生成します',
      },
      pending: '待機中',
      inProgress: '処理中',
      completed: '完了',
      failed: '失敗',
      cancel: '分析をキャンセル',
    },
  results: {
      title: '分析結果',
      description: 'DRBFM分析結果の詳細を確認できます。',
      summary: 'サマリー',
      designChanges: '変更点',
      failureModes: '故障モード',
      countermeasures: '対策案',
      exportHTML: 'HTMLでエクスポート',
      exportPDF: 'PDFでエクスポート',
      export: 'エクスポート',
      exporting: 'エクスポート中...',
      newAnalysis: '新規分析',
      startNew: '新規分析を開始',
      backToInput: '入力画面に戻る',
      noResults: '分析結果がありません',
      tabsAria: 'DRBFM結果タブ',
    },
  stats: {
      designChanges: '変更点',
      failureModes: '故障モード',
      countermeasures: '対策案',
      critical: '重大: {{count}}件',
      highPriority: '高優先: {{count}}件',
      criticalRisks: '重大リスク',
      preventionActions: '予防対策',
      detectionActions: '検出対策',
      mitigationActions: '軽減対策',
    },
  status: {
      draft: '下書き',
      analyzing: '分析中',
      completed: '完了',
      failed: '失敗',
      pending: '待機中',
      inProgress: '処理中',
    },
  table: {
      category: 'カテゴリ',
      item: '項目',
      itemName: '項目名',
      oldSpec: '旧仕様',
      newSpec: '新仕様',
      specifications: '仕様比較',
      change: '変更内容',
      changeDescription: '変更内容',
      impact: '影響範囲',
      impactAreas: '影響範囲',
      failureMode: '故障モード',
      failureDescription: '故障モード',
      cause: '原因',
      failureCause: '原因',
      effect: '影響',
      failureEffect: '影響',
      severity: '重大度',
      severityScore: 'スコア',
      rpn: 'RPN',
      rpnScore: 'RPN',
      countermeasure: '対策',
      countermeasureType: '対策タイプ',
      type: 'タイプ',
      description: '説明',
      effectiveness: '有効性',
      priority: '優先度',
      reference: '参照情報',
      designChanges: '変更点',
      failureModes: '故障モード',
      countermeasures: '対策案',
      noData: 'データがありません',
    },
  severity: {
      critical: '重大',
      high: '高',
      medium: '中',
      low: '低',
    },
  countermeasureType: {
      prevention: '予防',
      detection: '検出',
      mitigation: '軽減',
    },
  category: {
      Material: '材料',
      Dimension: '寸法',
      Process: '工程',
      Structure: '構造',
      Surface: '表面',
      Tolerance: '公差',
      Function: '機能',
      Other: 'その他',
    },
  impactArea: {
      Design: '設計',
      Manufacturing: '製造',
      Quality: '品質',
      Safety: '安全性',
      Cost: 'コスト',
      Maintenance: '保守',
    },
};

export default core;
